import LineSeriesModel$1 from 'echarts/lib/chart/line/LineSeries';
import createSeriesData from 'echarts/lib/chart/helper/createSeriesData';
import type { LineEndLabelOption, LineSeriesOption } from 'echarts/types/src/chart/line/LineSeries';
import type { Text } from 'echarts/types/src/util/graphic';
import type SeriesModelType from 'echarts/types/src/model/Series';

export interface RankLineSeriesOption extends Omit<LineSeriesOption, 'type'> {
  type: 'dvRankLine';
  endLabel?: LineEndLabelOption & {
    afterInit: (endLabel: Text) => void;
  };
  withTimeline: {
    range: [number, number];
    maxRange: number;
    curIndex: number;
  };
}
export type RankLineSeriesModelType = SeriesModelType<RankLineSeriesOption> & RankLineSeriesModel;

class RankLineSeriesModel extends LineSeriesModel$1 {
  static readonly type = 'series.dvRankLine';

  type = RankLineSeriesModel.type;

  static readonly dependencies = ['grid', 'polar'];

  hasSymbolVisual = true;

  getInitialData(option) {
    const data = createSeriesData(null, this, {
      useEncodeDefaulter: true
    });
    this._dvRawData = data;
    return data;
  }

  static defaultOption: RankLineSeriesOption = {
    // zlevel: 0,
    z: 3,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,

    clip: true,

    label: {
      position: 'top'
    },

    // itemStyle: {
    // },

    endLabel: {
      show: false,
      valueAnimation: true,
      distance: 8
    },

    lineStyle: {
      width: 2,
      type: 'solid'
    },

    emphasis: {
      scale: true
    },
    // areaStyle: {
    // origin of areaStyle. Valid values:
    // `'auto'/null/undefined`: from axisLine to data
    // `'start'`: from min to data
    // `'end'`: from data to max
    // origin: 'auto'
    // },
    // false, 'start', 'end', 'middle'
    step: false,

    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    symbol: 'emptyCircle',
    symbolSize: 4,
    symbolRotate: null,

    showSymbol: true,
    // `false`: follow the label interval strategy.
    // `true`: show all symbols.
    // `'auto'`: If possible, show all symbols, otherwise
    //           follow the label interval strategy.
    showAllSymbol: 'auto',

    // Whether to connect break point.
    connectNulls: false,

    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
    sampling: 'none',

    animationEasing: 'linear',

    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity,

    universalTransition: {
      divideShape: 'clone'
    },

    triggerLineEvent: false
  };
}

export default RankLineSeriesModel;
